<template>
  <v-dialog
    persistent
    width="300"
    v-model="loadingDialog"
  >
    <v-card
      color="pipefishGreen"
      dark
    >
      <v-card-text>
        {{loadingText}}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['loadingDialog', 'loadingText']

}
</script>

<style>

</style>
